module.exports = __webpack_public_path__ + "static/media/tipsImg11.5a021809.png";